import { makeStyles, Hidden } from '@material-ui/core'
import React, {useState} from 'react'
import { Topbar , Footer} from './components'

const useStyles = makeStyles((theme) => ({
    content: {
        
    }
}))

function Minimal(props) {
    const {children} = props
    const classes = useStyles()
   
    return (
        <div>
            <Topbar />
            <div className={classes.content}>
                {children}
            </div>
            <Footer />
        </div>
    )
}

export default Minimal